/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSettings(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M12 1.75A1.25 1.25 0 0010.75 3V3.173a2.4 2.4 0 01-1.455 2.196.75.75 0 01-.222.057 2.4 2.4 0 01-2.497-.54L6.57 4.88l-.06-.06a1.252 1.252 0 10-1.77 1.77l.066.066a2.4 2.4 0 01.49 2.625 2.4 2.4 0 01-2.188 1.549H3a1.25 1.25 0 000 2.5h.173a2.4 2.4 0 012.195 1.45 2.4 2.4 0 01-.482 2.644l-.006.006-.06.06a1.253 1.253 0 00.406 2.041 1.25 1.25 0 001.363-.271l.067-.066a2.4 2.4 0 012.625-.49 2.4 2.4 0 011.549 2.188V21a1.25 1.25 0 002.5 0V20.827a2.4 2.4 0 011.45-2.195 2.4 2.4 0 012.644.482l.006.006.06.06a1.253 1.253 0 001.364.271 1.256 1.256 0 00.406-2.04l-.066-.067a2.4 2.4 0 01-.482-2.643 2.4 2.4 0 012.195-1.451H21a1.25 1.25 0 000-2.5H20.827a2.4 2.4 0 01-2.196-1.455.753.753 0 01-.058-.222 2.4 2.4 0 01.54-2.497l.007-.006.06-.06a1.252 1.252 0 10-1.77-1.77l-.066.066a2.4 2.4 0 01-2.643.482 2.4 2.4 0 01-1.451-2.195V3A1.25 1.25 0 0012 1.75zm-1.944-.695A2.75 2.75 0 0114.75 3v.088a.9.9 0 00.545.823l.008.003a.9.9 0 00.99-.178l.056-.056a2.752 2.752 0 113.891 3.89l-.056.057a.9.9 0 00-.178.99c.027.061.046.125.055.19a.9.9 0 00.77.443H21a2.75 2.75 0 110 5.5h-.088a.9.9 0 00-.823.545l-.003.008a.9.9 0 00.178.99l.056.056a2.749 2.749 0 010 3.89 2.756 2.756 0 01-1.945.808 2.75 2.75 0 01-1.946-.807l-.056-.056a.9.9 0 00-.99-.178l-.007.003a.9.9 0 00-.546.823V21a2.75 2.75 0 11-5.5 0v-.08a.9.9 0 00-.589-.816.767.767 0 01-.044-.018.9.9 0 00-.99.178l-.056.056a2.748 2.748 0 01-3.892 0 2.749 2.749 0 010-3.89l.057-.057a.9.9 0 00.178-.99l-.003-.007a.9.9 0 00-.823-.546H3a2.75 2.75 0 110-5.5h.08a.9.9 0 00.816-.589.745.745 0 01.018-.044.9.9 0 00-.178-.99l-.056-.056A2.752 2.752 0 117.57 3.76l.057.056a.9.9 0 00.99.178.75.75 0 01.19-.056.9.9 0 00.443-.77V3c0-.73.29-1.429.806-1.945zM12 9.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 12a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z'
        />
      </g>
      <defs>
        <clipPath id='settings_svg__clip0_126_10541'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgSettings;
